import { Theme } from '@nykaa/ui-components/themes/types';

/**
 * Resolve theme color from token (e.g., 'primary', 'textPrimary') or direct value (e.g., '#000')
 */
export function resolveThemeColor(theme: Theme, colorToken?: string): string {
  if (!colorToken) return 'currentColor';
  if (colorToken === 'currentColor') return 'currentColor';
  if (colorToken.startsWith('#')) return colorToken;

  const value = theme?.colors?.[colorToken];

  if (!value) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        `[Icons] Color token "${colorToken}" not found. Fallback to currentColor.`,
        '\nAvailable:', Object.keys(theme?.colors || {}).slice(0, 10).join(', ')
      );
    }
    return 'currentColor';
  }

  return value;
}

/**
 * Format icon list for error messages
 */
export function formatAvailableIcons(iconMap: Record<string, unknown>, limit: number = 10): string {
  const iconNames = Object.keys(iconMap);
  const displayed = iconNames.slice(0, limit);
  const remaining = iconNames.length - limit;

  return displayed.join(', ') + (remaining > 0 ? `, and ${remaining} more...` : '');
}
